module.exports = __webpack_public_path__ + "static/media/Vector.642d4352.svg";